import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, object, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import countActiveFilters from 'Utils/countActiveFilters'

import WithListingPageContext from '../../WithListingPageContext'

function ResetFiltersAction({
  resetFilters,
  numberOfActiveFilters = 0,
  selectedFilters,
  setSelectedFilters,
  lastUsedFilters = null,
  setLastUsedFilters,
  isLink = false,
  locale = 'en',
}) {
  const resetFiltersLabel = i18n.t('listingPage.filters.resetFilters', { ns: 'rails', lng: locale })
  const lastUsedLabel = i18n.t('listingPage.filters.lastUsed', { ns: 'rails', lng: locale })

  function getLabel() {
    if (lastUsedFilters) {
      return lastUsedLabel
    }

    return `${resetFiltersLabel}${numberOfActiveFilters > 0 ? ` (${numberOfActiveFilters})` : ''}`
  }

  function handleClick() {
    if (lastUsedFilters) {
      setSelectedFilters({
        newObject: lastUsedFilters,
        clearLastUsedFilters: false,
      })
      setLastUsedFilters(null)
      return
    }

    setLastUsedFilters(selectedFilters)
    resetFilters()
  }

  if (isLink) {
    if (numberOfActiveFilters === 0) {
      return null
    }

    return (
      <div className="cgt-legacy-link" onClick={handleClick}>
        {getLabel()}
      </div>
    )
  }

  return (
    <Button
      type="secondary"
      size="medium"
      customClass="reset-filters-button"
      onClick={handleClick}
      isActive={numberOfActiveFilters > 0}
    >
      {getLabel()}
    </Button>
  )
}

ResetFiltersAction.propTypes = {
  resetFilters: func.isRequired,
  numberOfActiveFilters: number,
  selectedFilters: object.isRequired,
  setSelectedFilters: func.isRequired,
  lastUsedFilters: object,
  setLastUsedFilters: func.isRequired,
  isLink: bool,
  locale: string,
}

const mapStateToProps = ({
  resetFilters,
  selectedFilters,
  setSelectedFilters,
  lastUsedFilters,
  setLastUsedFilters,
  locale,
}) => {
  const {
    fileTypesActiveFiltersCount,
    modelTypeActiveFiltersCount,
    polygonsActiveFiltersCount,
    licensesActiveFiltersCount,
    pricingActiveFiltersCount,
    metaverseActiveFiltersCount,
    priceRangeActiveFiltersCount,
    designersActiveFiltersCount,
  } = countActiveFilters(selectedFilters)

  const numberOfActiveFilters =
    fileTypesActiveFiltersCount +
    modelTypeActiveFiltersCount +
    polygonsActiveFiltersCount +
    pricingActiveFiltersCount +
    licensesActiveFiltersCount +
    metaverseActiveFiltersCount +
    priceRangeActiveFiltersCount +
    designersActiveFiltersCount

  return {
    resetFilters,
    numberOfActiveFilters,
    selectedFilters,
    setSelectedFilters,
    lastUsedFilters,
    setLastUsedFilters,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(ResetFiltersAction)
